import { slab, wallX, goal, sign, checkpoint, edgeLights, crusher, shatter, boost } from '../kit.js';

/**
 * CHAPTER 2, SECTOR 16: PISTON. Rhythm and press. Chapter 1 is the wave
 * corridor: four ceiling crushers whose phases are tuned so a walking pace
 * started at spawn threads every head (phases computed for 7.6 m/s with a
 * 0.75s+ margin; the ch1 suite probe pins both the safe walk and the death
 * of a 2s-late one). Chapter 2 is the press yard: a boost strip breaks the
 * glass shortcut the side crushers guard. Chapter 3 is the ascent: pistons
 * hang extended and slam DOWN, so the slow retract stroke is a rideable
 * elevator and the slam is the hazard, one mechanism playing both roles.
 */
export default {
  id: 'piston',
  name: 'PISTON',
  blurb: 'The machines kept the schedule.',
  mode: { type: 'sprint', par: 150 },
  redline: { seconds: 71 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 8], yaw: 0 },
  killY: -50,
  env: {
    fog: 0x10121a,
    fogDensity: 0.004,
    sky: { zenith: 0x070510, horizon: 0x180f26, glow: 0x6e2a8a, aurora: 0xd04cff },
    floorY: -300,
  },
  objects: [
    // ---- chapter 1: the wave corridor.
    slab(0, 0, -24, 14, 68, 'plate', 1.4),
    ...edgeLights(0, 0, -24, 14, 68, 'magenta'),
    wallX(-7.35, 0, -24, 68, 8, 'plate', 1.4),
    wallX(7.35, 0, -24, 68, 8, 'plate', 1.4),
    // The prefab's cycle clock is (t + phase) mod period. Walking arrivals
    // at each head front, MEASURED by fixed-dt trace (spawn accel included):
    // 2.25s, 3.57s, 4.89s, 6.21s. phase = (0.25 - arrival) mod 4 puts the
    // walker a quarter second into the open dwell as it enters, 0.8s clear
    // of the slam. (The first cut used (arrival - 0.25) - a sign error the
    // trace caught: crusher three slammed exactly on schedule, onto you.)
    crusher(0, 8, -12, [0, 1.05, -12], [12, 2, 5], 4, 2.0),
    crusher(0, 8, -22, [0, 1.05, -22], [12, 2, 5], 4, 0.68),
    crusher(0, 8, -32, [0, 1.05, -32], [12, 2, 5], 4, 3.36),
    crusher(0, 8, -42, [0, 1.05, -42], [12, 2, 5], 4, 2.04),
    sign(0, 3.2, 4, 0, ['PISTON', 'READ THE RHYTHM', 'WALK THE WAVE']),
    checkpoint(0, 0, -52),
    // x 4.5: at 5 the 3.7m panel grazed the east wall (inner face 6.65).
    sign(4.5, 2.6, -54, 0, ['COURIER LOG 03', 'THE MACHINES KEPT THE SCHEDULE', 'NOBODY TOLD THEM THE SHIFT ENDED'], '#d04cff'),

    // ---- chapter 2: the press yard. Glass blocks the straight line; the
    // strip breaks it. The side gaps are the slow route the presses guard.
    slab(0, 0, -80, 14, 44, 'plate', 1.4),
    boost(0, 0, -62, 4, 10, [0, 0, -1], 26, 32),
    shatter(0, 2.5, -78, [10, 5, 0.4], 28),
    crusher(-9, 3, -78, [-5.4, 3, -78], [4, 5, 3], 3, 0),
    crusher(9, 3, -78, [5.4, 3, -78], [4, 5, 3], 3, 1.5),
    sign(0, 3.4, -59, 0, ['THE PRESS YARD', 'SPEED OPENS THE WALL'], '#d04cff'),
    checkpoint(0, 0, -98),

    // ---- chapter 3: the ascent. Home is the TOP: the slam stroke comes
    // down fast (hazard), the retract stroke climbs slow (elevator).
    slab(0, 0, -122, 20, 36, 'plate', 1.4),
    ...edgeLights(0, 0, -122, 20, 36, 'magenta'),
    checkpoint(0, 0, -108),
    crusher(0, 12.6, -114, [0, 0.6, -114], [5, 1.5, 5], 5, 0),
    slab(-7, 12, -120, 6, 8, 'panel', 1.0),
    crusher(-7, 24.6, -126, [-7, 12.6, -126], [5, 1.5, 5], 5, 2.5),
    slab(0, 24, -132, 6, 8, 'panel', 1.0),
    crusher(0, 36.6, -136, [0, 24.6, -136], [5, 1.5, 5], 5, 1.2),
    slab(0, 36, -142, 12, 10, 'panel', 1.2),
    ...edgeLights(0, 36, -142, 12, 10, 'lime'),
    sign(0, 2.6, -111, 0, ['THE ASCENT', 'BOARD AT THE BOTTOM', 'RIDE THE RETURN STROKE'], '#d04cff'),
    goal(0, 36, -144, 0),
  ],
};
